import { configureStore } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import { combineReducers } from "redux";
import coursesReducer from "./courses";
// import messagesRducer from "./Message";
import authRducer from "./auth";
import finalExamReducer from "./finalExam";
import answerQuestionReducer from "./AnswersCourses";
// import productsRducer from "./product";
// import categoriesducer from "./categories";
// import layoutRducer from "./layout";
//  import localizationReducer from "./Localization";
//  import cartReducer from "./cart";

// import usersRducer from "./users";
import storage from "redux-persist/lib/storage"; // ✅ دي اللي بتشتغل على الويب (localStorage)

const persistConfig = {
    key: "root",
    version: 1,
    storage: storage,
    
};

const RootReducers = combineReducers({
   auth: authRducer,
   courses:coursesReducer,
   finalExam:finalExamReducer,
   answerQuestion:answerQuestionReducer
//    productsRducer,
//    categoriesducer,
//    layoutRducer,
//    currentLocal: localizationReducer,
// cartReducer:cartReducer
    // messages: messagesRducer,
    // users: usersRducer,
    // user: userRducer,




});

const persistedReducer = persistReducer(persistConfig, RootReducers);

export default configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});